import Logo from '@/assets/img/logo.svg';
import AuthRecoveryPassword from '@/components/auth/auth-recovery-password/AuthRecoveryPassword';

import classes from './AuthRecoveryPassword.module.scss';

const AuthRecoveryPasswordPage = () => {
	return (
		<section className={classes.container}>
			<div className={classes['img-container']}>
				<img
					src={Logo}
					alt='terabit logo'
					className={classes['img-container__logo']}
				/>
			</div>
			<AuthRecoveryPassword />
		</section>
	);
};

export default AuthRecoveryPasswordPage;
